import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { SubscriptionFeatureType } from '../../../types/subscription-feature.type'

@Component({
  selector: 'bmcore-tariff-feature',
  templateUrl: './bmcore-tariff-feature.component.html',
  styleUrls: ['./bmcore-tariff-feature.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTariffFeatureComponent implements OnInit {
  @Input() feature: SubscriptionFeatureType

  constructor() {}

  ngOnInit(): void {}

  getType(value: string | boolean) {
    return typeof value
  }
}
